module.exports = __webpack_public_path__ + "img/198.appliance_problem.70df450b.svg";